// src/PrivacyPolicy.js

import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const [markdownContent, setMarkdownContent] = useState('');

  useEffect(() => {
    fetch('/policy.md')
      .then(response => response.text())
      .then(text => setMarkdownContent(text))
      .catch(error => {
        console.error('Error loading markdown file:', error);
        // 오류 발생 시 대체 텍스트 설정
        setMarkdownContent('# 개인정보 처리방침\n\n문서를 불러오는 중 오류가 발생했습니다.');
      });
  }, []);

  return (
    <div className="privacy-policy-container">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdownContent}</ReactMarkdown>
    </div>
  );
};

export default PrivacyPolicy;
